import React from 'react'

const LocationServiceCard = ({serviceCenters}) => {
  if (!serviceCenters || serviceCenters.length === 0) return null;
  return (
    <>
    <div>
      <h5>จุดบริการที่เกี่ยวข้อง</h5>
      <ul>
        {serviceCenters.map((center) => (
          <li key={center._id}>
            {center.name} ({center.province})<br />
            พิกัด: {center.location.latitude}, {center.location.longitude}<br />
            <a href={center.location.map} target="_blank" rel="noopener noreferrer">ดูแผนที่</a>
            <div style={{ margin: '10px 0' }}>
              <iframe
                width="80%"
                height="200"
                frameBorder="0"
                style={{ border: 0 }}
                src={`https://www.google.com/maps?q=${center.location.latitude},${center.location.longitude}&hl=th&z=16&output=embed`}
                allowFullScreen
                title={`map-${center._id}`}
              ></iframe>
            </div>
          </li>
        ))}
      </ul>
    </div>
    </>
  )
}

export default LocationServiceCard
